import { Stack, Tab, Tabs } from '@mui/material';
import useAuth from 'hooks/useAuth';
import { FC, useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PopularCard from 'views/components/skeleton/PopularCard';
import DocumentClientForms from '../client-record/DocumentClientForms';
import MeasurableForms from '../client-record/MeasurableForms';
import UploadedDocuments from '../client-record/UploadedDocuments';

const DocumentsPage: FC = () => {
  const { userId } = useAuth();
  //
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (_: any, newTabValue: number) => setTabValue(newTabValue);
  const [selectedCustomForm, setSelectedCustomForm] = useState<any>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [file, setFile] = useState<any>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const showMeasurableForms = ['peacefulwellbeing.noustalk.com'].includes(window.location.hostname);

  const handleGetDocument = (id: string, name: string, link: string, contentType: string, documentId: string) => {
    setFile({ id, name, link, contentType, documentId });
    setAnchorEl(null);
  };

  const handleGetCustomForm = (formId: string, title: string) => {
    setSelectedCustomForm({ formId, title });
    setAnchorEl(null);
  };
  const renderTabContent = useCallback(() => {
    switch (tabValue) {
      case 0: {
        return <DocumentClientForms userId={userId as string} />;
      }
      case 1: {
        return <UploadedDocuments userId={userId as string} />;
      }
      case 2: {
        return ['peacefulwellbeing.noustalk.com'].includes(window.location.hostname) && <MeasurableForms userId={userId as string} />;
      }

      default:
        console.log('Irrelevant Choice');
    }
  }, [tabValue, userId]);
  if (!userId) return <PopularCard />;
  return (
    <Stack spacing={3} sx={{ height: '100%' }}>
      <Tabs value={tabValue} onChange={handleTabChange} sx={{ overflowX: 'auto' }}>
        <Tab label={<FormattedMessage defaultMessage="Document Client Forms" />} />
        <Tab label={<FormattedMessage defaultMessage="Uploaded Documents" />} />
        {showMeasurableForms && (
          <Tab
            label={<FormattedMessage defaultMessage="Measurable Forms" />}
            hidden={!['peacefulwellbeing.noustalk.com'].includes(window.location.hostname)}
            disabled={!['peacefulwellbeing.noustalk.com'].includes(window.location.hostname)}
          />
        )}
      </Tabs>
      {renderTabContent()}
    </Stack>
  );
};

export default DocumentsPage;
